import { cargaAssetsDisposicion } from "./assetsDisposicion";
import { cargaAssetsBotones} from "./assetsBotones";
import { cargaAssetsCajaTragamonedas } from "./assetsCajaTragamonedas";
import { cargaAssetsCartelesTematica } from "./assetsCartelesTematica";
import { cargaAssetsFondo } from "./assetsFondo";
import { cargaAssetsNumerosDisplay } from "./assetsNumerosDisplay";
import { cargaAssetsPalanca } from "./assetsPalanca";
import { cargaAssetsValoresTragamonedas } from "./assetsValoresTragamonedas";

/**
 * Carga todos los assets del juego de la ruleta
 * @param {*} scene 
 */
export function cargaAssetsPrincipal(scene) {

  //cargaAssetsDisposicion(scene);
  cargaAssetsBotones(scene);
  cargaAssetsCajaTragamonedas(scene);
  cargaAssetsCartelesTematica(scene);
  cargaAssetsFondo(scene);
  cargaAssetsNumerosDisplay(scene);
  cargaAssetsPalanca(scene);
  cargaAssetsValoresTragamonedas(scene);

}
